import { render, staticRenderFns } from "./user.vue?vue&type=template&id=976ce7ea&scoped=true&"
import script from "./user.vue?vue&type=script&lang=ts&"
export * from "./user.vue?vue&type=script&lang=ts&"
import style0 from "./user.vue?vue&type=style&index=0&id=976ce7ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976ce7ea",
  null
  
)

export default component.exports